export interface ISection {
  components: IComponent[];
  section_key: string;
}

export interface IDataSourceItem {
  next: string | ObjectType;
  is_static: boolean;
  now: string | ObjectType;
  time: number;
}

export interface IProperties {
  more_link?: string;
  more_link_style?: string;
  title?: string;
  event_key?: string;
  style?: string;
  tabs?: string;
  keys?: string;
  event_keys?: string;
  tips?: string;
  contents?: string;
  item_card_size?: 'M' | 'L' | 'Auto';
  img_url?: string;
  // cms btn
  alias?: string;
  background?: string;
  text?: string;
  button_style?: 'style1' | 'style2';
  link_url?: string;
  // cms divider
  color?: string;
  display_mode?: 'solid' | 'dotted';
  divider_height?: 'large' | 'middle' | 'small';
  // title
  font_size?: 'large' | 'middle' | 'small';
  align?: 'start' | 'end' | 'left' | 'right' | 'center' | 'justify' | 'match-parent';
  // text
  font_weight?: 'normal' | 'weight';
  italic?: 'normal' | 'italic';
  display_line?: string;
  // product array
  sub_title?: string;
  line?: string;
  // banner
  width_type?: string;
  autoplay?: string;
  rounded_corner?: string;
  horizontal_margin?: string;
  vertical_margin?: 'large' | 'middle' | 'small';
  title_style?: string;
  sub_title_style?: string;
  html_text?: string;
  icon?: string;
  sub_i18n_title?: string;
  desc?: string;
  html?: string;
  scroll?: string;
  // cms_introduce
  description?: string;
  description_color?: string;
  image_theme_color?: string;
  image_url?: string;
  left_btn_bg_color?: string;
  left_btn_fg_color?: string;
  left_btn_link?: string;
  left_btn_text?: string;
  right_btn_bg_color?: string;
  right_btn_fg_color?: string;
  right_btn_link?: string;
  right_btn_text?: string;
  title_color?: string;
}

export interface IComponent {
  component_priority: number;
  component_key: any;
  component_type: string;
  datasource: string[];
  component_config_id: number | string;
  properties: { [key: string]: string };
  sub_components?: IComponent[];
  component_instance_key: string;
  preview_data?: any;
}

export interface ICms {
  layout: {
    page_key: string;
    sections: ISection[];
    page_param?: ObjectType;
    staticRes?: any;
  };
  datasource: {
    [key: string]: IDataSourceItem;
  };
  version?: string;
}

export interface IExtraProps {
  userInfo?: ObjectType;
  isRobot?: boolean;
  [key: string]: any;
}

export interface ComponentProps {
  cmsComponentKey: string;
  componentDataSourceKey?: string;
  componentMultipleDataSourceKey?: string[];
  multipleDataSource?: any;
  postUrls?: string[];
  properties: IProperties;
  component_config_id: number | string;
  postUrl?: string;
  isStatic: boolean;
  data: any;
  loading?: boolean;
  link?: string;
  componentPosition?: number;
  componentPos?: number;
  basePosition?: number;
  trackClick?: () => void;
  isRobot?: boolean;
  isLogin?: boolean;
  title?: string;
  skeleton?: React.ReactElement;
  isGlobal?: boolean;
  showSoldBy?: boolean;
  showBrandName?: boolean;
  isWaterfallPage?: boolean;
  trackingContext?: ObjectType;
  filterMaxPurchasedCard?: boolean;
}

export enum ISize {
  small = 'small',
  middle = 'middle',
  large = 'large'
}

export enum IWeight {
  normal = 'normal',
  weight = 'weight'
}

export enum ImgSize {
  original_img = 'original_image',
  max_width = 'max_width',
  adaptive_width = 'adaptive_width'
}

export enum bgType {
  image = 'image',
  color = 'color'
}

export enum IStatus {
  yes = 'yes',
  no = 'no'
}

/**
 * 非通用加购接口更新时使用次属性
 */
export type customAddCartApi = 'mkplGroupOrder' | 'mkplSellerOrder' | 'miniMarket' | 'addon' | 'activityAddCart' | null;

export type PageTheme = {
  title_color?: string;
  title_font_size?: string;
};

export interface PoolExtraProps {
  uniqueVideoPlayerRef?: React.MutableRefObject<any>;
  showSoldBy?: boolean;
  showPantryIcon?: boolean;
  transformProductLink?: (
    data: Record<string, any>
  ) => {
    to: string;
    reload: boolean;
  };
  trackingContext?: ObjectType;
  addCartParams?: {
    source?: string;
    referType: string;
  } & ObjectType;
  infiniteScrollOptions?: ObjectType;
  domId?: string; //无限加载组件的宿主容器id
  customAddCartApi?: customAddCartApi;
  pageTheme?: string | PageTheme;
  [key: string]: any;
}

export type TitleStyle = {
  align?: 'left' | 'center' | 'right';
  font_size?: 'middle' | 'large' | 'small';
  color?: string;
};

export type MoreLinkStyle = TitleStyle;

export type SubTitleStyle = TitleStyle;

export type ComponentBackground = {
  type?: 'image' | 'color';
  value?: string;
};

export type ComponentProperties = {
  title_style?: string;
  title?: string;
  event_key?: string;
  more_link_style?: string;
  sub_title_style?: string;
  background?: string;
  vertical_margin?: 'large' | 'middle' | 'small';
  [key: string]: any;
};

export interface CmsComponentOriginProps {
  componentDataSourceKey: string;
  title: string;
  cmsComponentKey: string;
  isStatic: boolean;
  properties: ComponentProperties;
  componentPos: number;
  /** 基础的位置，应用于cms在某个页面的模块开始 */
  basePosition: number;
  //ts类型, 如果 isStatic 为 true, 则存在 data 属性, 否则存在 postUrl 属性
  data?: any;
  postUrl?: string;
  subComponents?: IComponent[];
}

export interface CmsComponentProps extends CmsComponentOriginProps, PoolExtraProps {}

export interface CmsSsrComponentProps {
  componentKey: string;
  componentInstanceKey: string;
  componentDataSourceKey?: string;
  fetchUrl?: string;
  componentPosition: number;
  trackingContext: { [key: string]: unknown };
  properties: { [key: string]: any };
  staticRes?: any;
  uniqueVideoPlayerRef?: any;
  top?: number;
  onDataSourceError?: () => void;
  isPreview?: boolean;
  useInViewConfig?: {
    threshold?: number;
    rootMargin?: string;
  };
}
